module.exports = __webpack_public_path__ + "img/9788952759931.196aae54.jpg";